import { render, staticRenderFns } from "./PnetMessageView.vue?vue&type=template&id=26c579b6"
import script from "./PnetMessageView.vue?vue&type=script&lang=js"
export * from "./PnetMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports